import type { UtilityContext } from '@change-corgi/core/react/utilityContext';
import type { AuthMethod } from '@change-corgi/middle-end-gql-schema';

import type { User } from 'src/app/pages/loginOrSignup/shared/types';

import type { CreateUserParams } from './api/createUser';
import { createUser } from './api/createUser';
import { getEmailAuthMethod } from './api/getEmailAuthMethod';
import type { LoginByEmailMutationInput, LoginMutationResponse } from './api/loginByEmail';
import { loginByEmail } from './api/loginByEmail';
import type { LoginByOtpResponse } from './api/loginByOtp';
import { loginByOtp } from './api/loginByOtp';
import type { RequestOtpEmailResponse } from './api/requestOtpEmail';
import { requestOtpEmail } from './api/requestOtpEmail';

export type LoginOrSignupHook = {
	getEmailAuthMethod: (email: string, utilityContext: UtilityContext) => Promise<AuthMethod>;
	login: (params: LoginByEmailMutationInput, utilityContext: UtilityContext) => Promise<LoginMutationResponse>;
	signup: (params: CreateUserParams, utilityContext: UtilityContext) => Promise<User | boolean>;
	requestOtpEmail: (input: { email: string }, utilityContext: UtilityContext) => Promise<RequestOtpEmailResponse>;
	loginByOtp: (input: { email: string; otp: string }, utilityContext: UtilityContext) => Promise<LoginByOtpResponse>;
};

export function useLoginOrSignup(): LoginOrSignupHook {
	return {
		getEmailAuthMethod,
		login: loginByEmail,
		signup: createUser,
		requestOtpEmail,
		loginByOtp,
	};
}
